import { initBehaviors, destroyBehaviors } from '../../../shared/utilities/behaviors';
import BaseBehavior from '../../../framework/base/base';
import { removeComments } from '../../../shared/utilities/comments';
import { htmlDecode } from '../../../shared/utilities/html';
import { initScripts } from '../../../shared/utilities/scripts';
import { itemSlider } from '../../organisms/onpagenav/item-slider';

const classes = {
	active: 'active'
};

const selectors = {
	handle: 'handle',
	tab: 'tab'
};

export default class DetailedTabComponent extends BaseBehavior {
	constructor(element) {
		super(element);
		this.initDomCache();
		// Remove below assigment as part of clean post old tab compoenet is deleted from sitecore.
		if (!this.dom.content) {
			this.dom.content = this.element.querySelector(`[data-ref="tab__content"]`);
		}
		this.handles = this.findElementsByKeyPart(selectors.handle).filter(
			handle => handle.dataset.target
		);
		if (!this.handles.length) {
			this.tabs = this.findElementsByKeyPart(selectors.tab);
		}
		this.setupVDom();
		this.addEventListeners();
		itemSlider(element.querySelector('.v2-item-slider'));
	}

	findElementsByKeyPart(keyPart) {
		return Object.keys(this.dom)
			.filter(k => k.includes(keyPart))
			.map(k => this.dom[k]);
	}

	/* /static getTargetId(target) {
		return (target && target.indexOf('#') === 0 && target.substr(1)) || null;
	}
	/ */

	getContents(targetElement, index, initialActivetabIndex) {
		if (index === initialActivetabIndex) return targetElement.innerHTML;
		let contentHolder = null;
		if ('content' in document.createElement('template')) {
			contentHolder = document.createElement('div');
			contentHolder.appendChild(targetElement.content.cloneNode(true));
		}
		contentHolder = contentHolder || targetElement;
		return targetElement.dataset.htmlEncoded
			? htmlDecode(contentHolder.innerHTML)
			: contentHolder.innerHTML;
	}

	setupVDom() {
		this.vdom = {};
		if (this.handles && !this.tabs) {
			this.tabs = this.handles
				.map(element => {
					const id = element.dataset.target;
					return id && document.querySelector(`*[data-tabid='${id}']`);
				})
				.filter(tab => tab);
		}
		const initialActivetabIndex = this.handles.findIndex(element =>
			element.classList.contains('active')
		);
		this.tabs.forEach((targetElement, index) => {
			/** Remove `data-instance-init` attr so that, script could be re-run
			 * by behaviors js, on tab re-load
			 * Taking this out from else block  as in IE data-behavior inside a template tag also gets initialized
			 * */
			Array.from(targetElement.querySelectorAll('[data-instance-init]')).forEach(elt => {
				elt.removeAttribute('data-instance-init');
			});
			// since active index tab will firstrender directly, so its markup should not
			// pass in remove comments, otherwise that comment will be rendered.
			if (targetElement.tagName === 'TEMPLATE' || index === initialActivetabIndex) {
				this.vdom[targetElement.dataset.tabid] = this.getContents(
					targetElement,
					index,
					initialActivetabIndex
				);
			} else {
				this.vdom[targetElement.dataset.tabid] = removeComments(targetElement.outerHTML);
			}
		});
	}

	addEventListeners() {
		if (!this.handles.length) {
			return;
		}

		if (this.handles.length > 1) {
			this.handles.forEach((handle, i) => {
				this.addEventListener(handle, 'click.handle' + i, e => {
					e.preventDefault();
					if (!e.target.matches('.active')) {
						this.openTab(handle.dataset.target, handle);
					}
				});
			});
		}
	}

	removeEventListeners() {
		this.handles.forEach((handle, i) => this.removeEventListener(handle, 'click.handle' + i));
	}

	openTab(selectedRef, handle) {
		this.handles.forEach(element => element.classList.remove(classes.active));
		if (handle) {
			handle.classList.add(classes.active);
		}

		if (this.vdom[selectedRef]) {
			this.populateTabFromVDom(selectedRef);
		}
	}

	populateTabFromVDom(selectedRef) {
		destroyBehaviors({ context: this.dom.content });
		this.dom.content.innerHTML = this.vdom[selectedRef];
		initBehaviors({ context: this.dom.content });
		initScripts(this.dom.content, `*[data-tabid='${selectedRef}'`);
		if (window.picturefill) {
			window.picturefill({ elements: this.dom.content.querySelectorAll('picture img') });
		}
		if (window.objectFitPolyfill) {
			window.objectFitPolyfill({
				elements: this.dom.content.querySelectorAll('img[data-object-fit]')
			});
		}
	}

	cleanup() {
		this.removeEventListeners();
		this.vdom = {};
	}
}
